import styled from '@emotion/styled';
import { css } from '@emotion/core';

export const Row = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  margin-bottom: ${({ separated }) => (separated ? '30px' : 0)};
  padding-bottom: ${({ separated }) => (separated ? '30px' : 0)};
  border-bottom: ${({ separated }) =>
    separated ? '1px rgba(0,0,0,0.1) solid' : 'none'};
  position: relative;
  flex-direction: ${({ column }) => (column ? 'column' : 'row')};

  align-items: ${({ top }) => (top ? 'center' : 'initial')};

  overflow: ${({ withScroll }) => (withScroll ? 'auto' : 'initial')};

  > img {
    display: block;
    margin-right: 15px;
    height: auto;
    object-fit: contain;
    align-self: flex-start;
  }

  ${({ dimmed }) =>
    dimmed
      ? css`
          &:before {
            content: '';
            display: block;
            position: absolute;
            z-index: 2;
            bottom: 0;
            left: 0;
            width: 100%;
            height: 150px;
            pointer-events: none;
          }
        `
      : null}
`;

export const Col = styled.div`
  width: ${({ fullwidth }) => (fullwidth ? '100%' : 'auto')};

  & + & {
    margin-left: 15px;
  }
`;

export const Title = styled.h1`
  font-size: 40px;
  font-weight: 500;
  color: ${({ theme }) => theme.palette.base};
  display: block;
  margin-bottom: 10px;
`;

export const Detail = styled.div`
  color: #2b2b2b;

  & + & {
    margin-top: 5px;
  }
`;

export const Description = styled.p`
  font-size: 16px;
  line-height: 24px;
`;

export const ScrollableList = styled.div`
  max-height: calc(100vh - 390px);
  overflow-y: scroll;
  position: relative;
  padding-bottom: 50px;
`;

export const DownloadBar = styled.div`
  padding: 10px;
  display: flex;
  justify-content: center;
  box-shadow: 0 -5px 5px rgba(0, 0, 0, 0.03);
  background-color: #f5f5f5;
  position: relative;
  z-index: 5;
  font-weight: 700;
  margin: 15px 0;
`;

export const DownloadButton = styled.button`
  border-radius: 6px;
  display: flex;
  align-items: center;
  transition: background-color 0.3s ease-in-out;
  background-color: ${({ theme }) => theme.buttons.primary.backgroundColor};
  color: ${({ theme }) => theme.buttons.primary.textColor};
  text-transform: uppercase;
  padding: 11px 16px;
  font-size: 20px;
  line-height: 26px;
  font-weight: 600;
`;

export const Buttons = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

export const AlbumDownloadWrapper = styled.div`
  width: 100%;
  max-width: 300px;
`;

export const TracksDownloadWrapper = styled.div`
  padding: 0 11px 20px;
  width: 100%;
`;
